import React, { useEffect, useState, useLayoutEffect, useRef } from "react"
import ReactDOM from 'react-dom'
import { useStaticQuery, graphql } from 'gatsby'
import Swiper from 'react-id-swiper'
import Img from 'gatsby-image'
import { SketchTeFront, SketchTeBack } from './sketch-te'
import { SketchSaFront, SketchSaBack } from './sketch-sa'
import TeFront from './svg/te-front'
import TeBack from './svg/te-back'
import SaFront from './svg/sa-front'
import SaBack from './svg/sa-back'
import useWindowDimensions from './useWindowDimensions'
import 'swiper/css/swiper.css'
import '../styles/modules/_swiper.scss'

const Monitor = ({ currentDesign, currentStage, currentSide, changeSide, currentMetaInfo, currentProduct, bannerDisplay }) => {
  const [gallerySwiper, getGallerySwiper] = useState(null);

  // const updateSlide = () => {
  //   if (gallerySwiper !== null) {
  //     gallerySwiper.update();
  //   }
  // };
  const gotoSlide = (currentSide) => {
    if (gallerySwiper !== null) {
      if (currentSide === 'front') {
        gallerySwiper.slideTo(0, 500);
      } else {
        gallerySwiper.slideTo(1, 500);
      }
    }
  };
  // useEffect(() => updateSlide(), [currentStage, currentMetaInfo]);
  useEffect(() => gotoSlide(currentSide), [currentSide]);

  const monitorRef = useRef();

  const gallerySwiperParams = {
    pagination: {
      el: '.swiper-pagination.collection__pagination',
      type: 'bullets',
      clickable: true
    },
    slidesPerView: 1,
    spaceBetween: 30,
    // breakpoints: {
    //   1200: {
    //     slidesPerView: 3,
    //     spaceBetween: 20
    //   },
    //   768: {
    //     slidesPerView: 2,
    //     spaceBetween: 10
    //   }
    // }
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    renderPrevButton: () => <button className="swiper-button-prev"><i className="icon icon-prev"/></button>,
    renderNextButton: () => <button className="swiper-button-next"><i className="icon icon-next"/></button>,
    on:{
      slideChange: function(){
        if (this.activeIndex === 0) {
          changeSide('front')
        } else if (this.activeIndex === 1) {
          changeSide('back')
        }
      }
    },
    getSwiper: getGallerySwiper
  }

  let currrentComposition = currentDesign
  const data = useStaticQuery(graphql`
    query {
      garden: file(relativePath: { eq: "garden.jpg" }) {
        childImageSharp {
          fluid(base64Width: 840) {
            base64
          }
        }
      },
      rust: file(relativePath: { eq: "rust.jpg" }) {
        childImageSharp {
          fluid(base64Width: 840) {
            base64
          }
        }
      },
      green: file(relativePath: { eq: "green.jpg" }) {
        childImageSharp {
          fluid(base64Width: 840) {
            base64
          }
        }
      },
      beige: file(relativePath: { eq: "beige.jpg" }) {
        childImageSharp {
          fluid(base64Width: 840) {
            base64
          }
        }
      },
      grey: file(relativePath: { eq: "grey.jpg" }) {
        childImageSharp {
          fluid(base64Width: 840) {
            base64
          }
        }
      },
      violet: file(relativePath: { eq: "violet.jpg" }) {
        childImageSharp {
          fluid(base64Width: 840) {
            base64
          }
        }
      },
      black: file(relativePath: { eq: "black.jpg" }) {
        childImageSharp {
          fluid(base64Width: 840) {
            base64
          }
        }
      },
      webbing: file(relativePath: { eq: "webbing.jpg" }) {
        childImageSharp {
          fluid(base64Width: 390) {
            base64
          }
        }
      }
    }
  `)
  const getPattern = (color) => {
    let image
    switch(color) {
      case 'garden':
        image = data.garden.childImageSharp.fluid.base64
        break;
      case 'rust':
        image = data.rust.childImageSharp.fluid.base64
        break;
      case 'green':
        image = data.green.childImageSharp.fluid.base64
        break;
      case 'beige':
        image = data.beige.childImageSharp.fluid.base64
        break;
      case 'grey':
        image = data.grey.childImageSharp.fluid.base64
        break;
      case 'violet':
        image = data.violet.childImageSharp.fluid.base64
        break;
      case 'black':
        image = data.black.childImageSharp.fluid.base64
        break;
      case 'mesh':
        image = data.mesh.childImageSharp.fluid.base64
        break;
      case 'webbing':
        image = data.webbing.childImageSharp.fluid.base64
        break;
      default:
        image = ''
    }
    return image
  }
  const getColor = (color, comp) => {
    let colorHex
    switch(color) {
      case 'white':
        colorHex = '#ffffff'
        break;
      case 'white_z':
        colorHex = '#ffffff'
        break;
      case 'black_z':
        colorHex = '#000000'
        break;
      case 'black_p':
        colorHex = '#000'
        break;
      case 'brown_p':
        colorHex = '#562E1E'
        break;
      case 'grey_p':
        colorHex = '#777'
        break;
      case 'garden':
        colorHex = 'url(#garden)'
        break;
      case 'rust':
        colorHex = 'url(#rust)'
        break;
      case 'green':
        colorHex = 'url(#green)'
        break;
      case 'green_t':
        colorHex = 'url(#green)'
        break;
      case 'beige':
        colorHex = 'url(#beige)'
        break;
      case 'grey':
        colorHex = 'url(#grey)'
        break;
      case 'violet':
        colorHex = 'url(#violet)'
        break;
      case 'purple_t':
        colorHex = 'url(#violet)'
        break;
      case 'black':
        colorHex = 'url(#black)'
        break;
      case 'black_t':
        colorHex = 'url(#black)'
        break;
      case 'webbing':
        colorHex = 'url(#webbing)'
        break;
      default:
        colorHex = ''
    }
    return colorHex
  }
  const getLineColor = (color, comp) => {
    let colorHex
    // if ( color === 'black') {
    //   colorHex = comp === 'webbing' || comp === 'zipper' ? '#fff' : '#000'
    // } else if ( color === 'black_l') {
    //   colorHex = '#C2C0BF'
    // } else {
    //   colorHex = '#231F20'
    // }
    // if ( color === 'black' || color === 'violet' || color === 'grey' || color === 'green'  ) {
    //   colorHex = '#C2C0BF'
    // } else {
    //   colorHex = '#231F20'
    // }
    switch(color) {
      case 'white_z':
        colorHex = '#000000'
        break;
      case 'black_z':
        colorHex = '#ffffff'
        break;
      default:
        colorHex = '#231F20'
    }
    return colorHex
  }
  const showSoftZipper = (color) => {
    const show = color === 'grey_p'
    return show
  }
  const showPointPattern = (color) => {
    const show = color === 'navy' || color === 'coyote'
    return show
  }
  // const size = useWindowSize(monitorRef);
  const size = useWindowDimensions()

  return (
    <div className="monitor" ref={monitorRef}>
      <Swiper
        {...gallerySwiperParams}
      >
        <div>
          <div className="svg-container">
          { currentProduct === 'sacoche' ? (
          <SketchSaFront
            getColor={getColor}
            getPattern={getPattern}
            getLineColor={getLineColor}
            showSoftZipper={showSoftZipper}
            showPointPattern={showPointPattern}
            currrentComposition={currrentComposition}
            size = {size}
          />
          ) : (
          <SketchTeFront
            getColor={getColor}
            getPattern={getPattern}
            getLineColor={getLineColor}
            showSoftZipper={showSoftZipper}
            showPointPattern={showPointPattern}
            currrentComposition={currrentComposition}
            currentStage={currentStage}
            size = {size}
          />
          )}
          </div>
        </div>
        <div>
          <div className="svg-container">
          { currentProduct === 'sacoche' ? (
            <SketchSaBack
              getColor={getColor}
              getLineColor={getLineColor}
              showSoftZipper={showSoftZipper}
              showPointPattern={showPointPattern}
              currrentComposition={currrentComposition}
              getPattern={getPattern}
              size = {size}
            />
            ) : (
            <SketchTeBack
              getColor={getColor}
              getLineColor={getLineColor}
              showSoftZipper={showSoftZipper}
              showPointPattern={showPointPattern}
              currrentComposition={currrentComposition}
              currentStage={currentStage}
              getPattern={getPattern}
              size = {size}
            />
            )}
          </div>
        </div>
        {/* <div style={{ display: currentStage === 'design-pick' && currentMetaInfo.featuredImage ? 'block' : 'none'}}>
          { currentMetaInfo.featuredImage ? (
            <Img style={{width: '100%', position: 'absolute'}} fluid={currentMetaInfo.featuredImage.childImageSharp.fluid} />
          ) : (
            <></>
          ) }
        </div> */}
      </Swiper>
    </div>
  )
}

// const useWindowSize = (monitorRef) => {
//   const [size, setSize] = useState([0, 0]);
//   var node = ReactDOM.findDOMNode(monitorRef.current);
//   if (node){
//     var calculatedHeight = node.clientHeight;
//     var calculatedWidth = node.clientWidth;
//   }
//   useLayoutEffect(() => {
//     function updateSize() {
//       setSize([window.innerHeight, window.innerWidth]);
//     }
//     window.addEventListener('resize', updateSize);
//     updateSize();
//     return () => window.removeEventListener('resize', updateSize);
//   }, []);
//   return size;
// }


export default Monitor
